(() => {
  const roots = document.querySelectorAll('[data-pb-aw26]');
  roots.forEach(init);

  function init(root) {
    const copy = JSON.parse(root.querySelector('[data-pb-copy]').textContent);
    const locale = root.dataset.locale === 'de' ? 'de' : 'en';
    const gate = root.querySelector('[data-gate]');
    const experience = root.querySelector('[data-experience]');
    const unlockForm = root.querySelector('[data-unlock-form]');
    const passwordInput = root.querySelector('[data-password]');
    const unlockMessage = root.querySelector('[data-unlock-message]');
    const sticky = root.querySelector('[data-open-drawer]');
    const drawer = root.querySelector('[data-drawer]');
    const sizeDialog = root.querySelector('[data-size-dialog]');
    const sizeDialogClose = root.querySelector('[data-close-size-dialog]');
    const selections = new Map(readSelection());
    let sizeGuideOpener;
    let catalog;
    let assetBase;
    let submitting = false;

    unlockForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      unlockMessage.textContent = copy.loading;
      try {
        const result = await decryptCatalog(passwordInput.value);
        const key = await deriveKey(passwordInput.value, result.payload);
        sessionStorage.setItem('pb-aw26-key', bytesToBase64(new Uint8Array(await crypto.subtle.exportKey('raw', key))));
        passwordInput.value = '';
        openExperience(result.catalog);
      } catch (error) {
        unlockMessage.textContent = copy.wrongPassword;
        passwordInput.select();
      }
    });

    sticky.addEventListener('click', () => drawer.showModal());
    root.querySelector('[data-close-drawer]').addEventListener('click', () => drawer.close());
    root.querySelector('[data-review-link]').addEventListener('click', () => drawer.close());
    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) drawer.close();
    });
    sizeDialogClose.addEventListener('click', () => sizeDialog.close());
    sizeDialog.addEventListener('click', (event) => {
      if (event.target === sizeDialog) sizeDialog.close();
    });
    sizeDialog.addEventListener('close', () => sizeGuideOpener?.focus());

    const contactForm = root.querySelector('.pb-aw26__contact');
    if (contactForm) {
      contactForm.addEventListener('submit', (event) => {
        if (submitting) { event.preventDefault(); return; }
        const message = root.querySelector('[data-form-message]');
        if (selections.size === 0) {
          event.preventDefault();
          message.textContent = copy.zeroSelection;
          root.querySelector('[data-catalog]').scrollIntoView({ block: 'start' });
          return;
        }
        if ([...selections.values()].some((item) => !item.size)) {
          event.preventDefault();
          message.textContent = copy.missingSize;
          renderReview();
          return;
        }
        const details = [...new FormData(contactForm).entries()]
          .filter(([name]) => !['contact[body]', 'form_type', 'utf8'].includes(name))
          .map(([name, value]) => `${name.replace(/^contact\[|\]$/g, '')}: ${value}`);
        const lines = [...selections.values()].map((item) =>
          `${item.styleCode} | ${item.color.en} | Size ${item.size} | EUR ${item.rrpEur.toFixed(2)}`
        );
        root.querySelector('[data-contact-body]').value = [
          'QA/PRODUCTION SOURCE: AW26 Influencer Selection', '', ...details, '', 'SELECTION', ...lines
        ].join('\n');
        submitting = true;
        root.querySelector('[data-submit]').disabled = true;
        root.querySelector('[data-submit]').textContent = copy.submitting;
      });
    }

    const success = root.querySelector('[data-success]');
    if (success) {
      sessionStorage.removeItem('pb-aw26-selection');
      success.focus();
    }

    resumeSession();

    async function resumeSession() {
      const stored = sessionStorage.getItem('pb-aw26-key');
      if (!stored) return;
      try {
        const key = await crypto.subtle.importKey('raw', base64ToBytes(stored), 'AES-GCM', false, ['decrypt']);
        openExperience(await decryptWithKey(key, window.PBAW26EncryptedCatalog));
      } catch (error) {
        sessionStorage.removeItem('pb-aw26-key');
      }
    }

    function openExperience(data) {
      catalog = data;
      assetBase = assetUrlFactory(root.dataset.assetProbe);
      gate.hidden = true;
      experience.hidden = false;
      experience.inert = false;
      sticky.hidden = false;
      renderEditorial();
      renderLookbook();
      renderReview();
      root.dispatchEvent(new CustomEvent('pb-aw26:ready', { bubbles: true, detail: { count: catalog.products.length } }));
    }

    function renderEditorial() {
      const map = {
        cover: override('cover') || assetBase(catalog.editorial.cover, 2200),
      };
      root.querySelectorAll('[data-editorial]').forEach((image) => {
        image.src = map[image.dataset.editorial];
        if (image.dataset.editorial === 'cover' && root.dataset.coverMobileOverride) {
          const picture = document.createElement('picture');
          const source = document.createElement('source');
          source.media = '(max-width: 767px)';
          source.srcset = root.dataset.coverMobileOverride;
          image.before(picture); picture.append(source, image);
        }
      });
    }

    function override(key) { return root.dataset[`${key}Override`] || ''; }

    function renderLookbook() {
      const container = root.querySelector('[data-lookbook]');
      const productsByCode = new Map();
      catalog.products.forEach((product) => {
        const items = productsByCode.get(product.styleCode) || [];
        items.push(product);
        productsByCode.set(product.styleCode, items);
      });
      const nodes = [];
      let currentStory = '';
      catalog.looks.forEach((look) => {
        if (look.story !== currentStory) {
          currentStory = look.story;
          const visible = root.dataset[currentStory === 'greek-cat' ? 'showGreek' : 'showInk'] === 'true';
          if (visible) nodes.push(storyIntro(currentStory));
        }
        const lookProducts = look.styleCodes.flatMap((code) => productsByCode.get(code) || []);
        nodes.push(lookSection(look, lookProducts));
      });
      container.replaceChildren(...nodes);
    }

    function storyIntro(story) {
      const intro = el('section', 'pb-aw26__chapter');
      const number = story === 'greek-cat' ? '02' : '01';
      const title = story === 'greek-cat' ? copy.greekTitle : copy.inkTitle;
      const body = story === 'greek-cat' ? copy.greekCopy : copy.inkCopy;
      intro.append(el('p', 'pb-aw26__kicker', `${number} / PRINT STORY`), el('h2', '', title), el('p', '', body));
      return intro;
    }

    function lookSection(look, products) {
      const section = el('section', 'pb-aw26__look');
      const headingId = `pb-aw26-look-${look.number}-${root.id}`;
      section.setAttribute('aria-labelledby', headingId);
      const visual = el('figure', 'pb-aw26__look-visual');
      const image = document.createElement('img');
      const overrideUrl = lookOverride(look);
      image.src = overrideUrl || assetBase(look.image, 1800);
      if (!overrideUrl) image.srcset = `${assetBase(look.image, 900)} 900w, ${assetBase(look.image, 1400)} 1400w, ${assetBase(look.image, 1800)} 1800w`;
      image.sizes = '(max-width: 767px) 100vw, 1100px';
      image.loading = 'lazy'; image.width = 1800; image.height = 2400;
      image.alt = `${copy.look} ${String(look.number).padStart(2, '0')}, ${products.map((product) => `${product.title[locale]}, ${product.color[locale]}`).join('; ')}`;
      const folio = el('figcaption', 'pb-aw26__folio', `POCO BLUSH / #14 / ${copy.look.toUpperCase()} ${String(look.number).padStart(2, '0')}`);
      visual.append(image, folio);
      const productBand = el('div', 'pb-aw26__look-products');
      const header = el('div', 'pb-aw26__look-heading');
      const kicker = el('p', 'pb-aw26__kicker', `${copy.look} ${String(look.number).padStart(2, '0')}`);
      const heading = el('h3', '', copy.lookStyles); heading.id = headingId;
      const headingMain = el('div', 'pb-aw26__look-heading-main');
      headingMain.append(heading);
      if (root.dataset.showSizeGuide === 'true') headingMain.append(sizeGuideButton());
      header.append(kicker, headingMain);
      const grid = el('div', 'pb-aw26__grid pb-aw26__grid--look');
      grid.append(...products.map(productCard));
      productBand.append(header, grid);
      section.append(visual, productBand);
      return section;
    }

    function sizeGuideButton() {
      const button = el('button', 'pb-aw26__size-guide-trigger', copy.sizeGuide);
      button.type = 'button';
      button.setAttribute('aria-haspopup', 'dialog');
      button.addEventListener('click', () => {
        sizeGuideOpener = button;
        sizeDialog.showModal();
      });
      return button;
    }

    function lookOverride(look) {
      const storyIndex = catalog.looks.filter((item) => item.story === look.story).findIndex((item) => item.number === look.number);
      if (look.story === 'greek-cat') return storyIndex === 0 ? override('greekOne') : storyIndex === 1 ? override('greekTwo') : '';
      return storyIndex === 0 ? override('inkOne') : storyIndex === 1 ? override('inkTwo') : '';
    }

    function productCard(product) {
      const article = el('article', 'pb-aw26__card');
      article.dataset.productId = product.id;
      const media = el('div', 'pb-aw26__media');
      const image = document.createElement('img');
      image.src = assetBase(product.image, 900);
      image.srcset = `${assetBase(product.image, 480)} 480w, ${assetBase(product.image, 720)} 720w, ${assetBase(product.image, 900)} 900w`;
      image.sizes = '(max-width: 767px) 100vw, (max-width: 1050px) 50vw, 33vw';
      image.loading = 'lazy'; image.width = 1500; image.height = 1500;
      image.alt = `${product.title[locale]}, ${product.color[locale]}`;
      media.append(image);
      const meta = el('div', 'pb-aw26__meta');
      meta.append(el('h4', '', product.title[locale]), el('p', '', `${product.styleCode} / ${product.color[locale]}`), el('p', 'pb-aw26__price', `EUR ${product.rrpEur.toFixed(2)} RRP`));
      const label = el('label', 'pb-aw26__size', copy.size);
      const select = document.createElement('select');
      select.setAttribute('aria-label', `${copy.size}: ${product.title[locale]}, ${product.color[locale]}`);
      select.append(option('', copy.selectSize), ...product.sizes.map((size) => option(size, size)));
      const chosen = selections.get(product.id);
      if (chosen) select.value = chosen.size || '';
      select.addEventListener('change', () => {
        if (!selections.has(product.id)) selectProduct(product, select.value);
        else { selections.get(product.id).size = select.value; persist(); renderReview(); }
      });
      label.append(select);
      const button = el('button', '', chosen ? copy.selected : copy.choose);
      button.type = 'button'; button.setAttribute('aria-pressed', String(Boolean(chosen)));
      button.addEventListener('click', () => {
        if (selections.has(product.id)) removeProduct(product.id);
        else selectProduct(product, select.value);
      });
      article.append(media, meta, label, button);
      return article;
    }

    function selectProduct(product, size) {
      selections.set(product.id, { ...product, size: size || '' });
      persist(); syncCard(product.id); renderReview();
    }

    function removeProduct(id) {
      selections.delete(id); persist(); syncCard(id); renderReview();
    }

    function syncCard(id) {
      const card = root.querySelector(`[data-product-id="${CSS.escape(id)}"]`);
      if (!card) return;
      const selected = selections.has(id);
      const button = card.querySelector('button');
      button.textContent = selected ? copy.selected : copy.choose;
      button.setAttribute('aria-pressed', String(selected));
      if (!selected) card.querySelector('select').value = '';
    }

    function renderReview() {
      const rows = [...selections.values()].map(reviewRow);
      [root.querySelector('[data-selection-inline]'), root.querySelector('[data-drawer-items]')].forEach((container) => {
        if (!container) return;
        container.replaceChildren(...(rows.length ? [...selections.values()].map(reviewRow) : [el('p', '', copy.empty)]));
      });
      root.querySelector('[data-count]').textContent = String(selections.size);
      root.querySelector('[data-sticky-label]').textContent = copy.review;
    }

    function reviewRow(item) {
      const row = el('div', 'pb-aw26__review-row');
      const image = document.createElement('img'); image.src = assetBase(item.image, 180); image.alt = '';
      const info = el('div'); info.append(el('p', '', item.title[locale]), el('p', '', `${item.styleCode} / ${item.color[locale]}`));
      const select = document.createElement('select');
      select.setAttribute('aria-label', `${copy.size}: ${item.title[locale]}, ${item.color[locale]}`);
      select.append(option('', copy.selectSize), ...item.sizes.map((size) => option(size, size)));
      select.value = item.size || '';
      select.addEventListener('change', () => { selections.get(item.id).size = select.value; persist(); renderReview(); syncCard(item.id); });
      const remove = el('button', 'pb-aw26__remove', copy.remove); remove.type = 'button';
      remove.setAttribute('aria-label', `${copy.remove}: ${item.title[locale]}, ${item.color[locale]}`);
      remove.addEventListener('click', () => removeProduct(item.id));
      row.append(image, info, select, remove);
      return row;
    }

    function persist() {
      sessionStorage.setItem('pb-aw26-selection', JSON.stringify([...selections.entries()]));
    }
  }

  async function decryptCatalog(password) {
    const payload = window.PBAW26EncryptedCatalog;
    const key = await deriveKey(password, payload);
    return { catalog: await decryptWithKey(key, payload), key, payload };
  }

  async function deriveKey(password, payload) {
    const material = await crypto.subtle.importKey('raw', new TextEncoder().encode(password), 'PBKDF2', false, ['deriveKey']);
    return crypto.subtle.deriveKey({ name: 'PBKDF2', salt: base64ToBytes(payload.salt), iterations: payload.iterations, hash: 'SHA-256' }, material, { name: 'AES-GCM', length: 256 }, true, ['encrypt', 'decrypt']);
  }

  async function decryptWithKey(key, payload) {
    const packed = base64ToBytes(payload.ciphertext);
    const plaintext = await crypto.subtle.decrypt({ name: 'AES-GCM', iv: base64ToBytes(payload.iv), additionalData: new TextEncoder().encode(payload.aad), tagLength: 128 }, key, packed);
    return JSON.parse(new TextDecoder().decode(plaintext));
  }

  function assetUrlFactory(probe) {
    const [path] = probe.split('?');
    const base = path.slice(0, path.lastIndexOf('/') + 1);
    return (filename, width) => `${base}${filename}?width=${width}&format=jpg`;
  }

  function readSelection() {
    try { return JSON.parse(sessionStorage.getItem('pb-aw26-selection') || '[]'); }
    catch (error) { sessionStorage.removeItem('pb-aw26-selection'); return []; }
  }
  function base64ToBytes(value) { return Uint8Array.from(atob(value), (char) => char.charCodeAt(0)); }
  function bytesToBase64(bytes) { return btoa(String.fromCharCode(...bytes)); }
  function el(tag, className = '', text = '') { const node = document.createElement(tag); if (className) node.className = className; if (text) node.textContent = text; return node; }
  function option(value, text) { const node = document.createElement('option'); node.value = value; node.textContent = text; return node; }
})();
